var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-bg"},[_c('div',{staticClass:"item-img"},[_c('img',{style:({border:  _vm.selected.includes(_vm.itemObj) ? '2px #015c61 solid'  : '' }),attrs:{"src":_vm.itemObj.thumb_path,"alt":"img"}}),_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.itemObj.scene_title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }